import { getDataWithQueryString } from "../../../../api/componentAPIs";

const loadDispatchKPIData = (terminalCode) => {
  return getDataWithQueryString(
    "DispatchKPI",
    `terminalCode=${terminalCode}`
  )
};


export {
    loadDispatchKPIData
}